import SellersApiV2 from 'api/v2/admins/sellers-api-v2'
import React, { useEffect, useState } from 'react'
import SellerBadge from 'domains/seller/atoms/seller-badge'
import PropTypes from 'prop-types'
import { useField } from 'formik'
import SelectField from 'components/molecules/select-field'

const propTypes = {
  name     : PropTypes.string,
  label    : PropTypes.string,
  required : PropTypes.bool
}

/**
 * Search field to select seller by seller code.
 * @param {string} name - Formik field name
 * @param {string} label - Field Label
 * @param {bool} required - It will show required badge if it set `true`
 */
const SellerSelectSearchField = ({
  name,
  label,
  required,
  ...props
}) => {
  const [ field ]                           = useField(name)
  const [ initialOption, setInitialOption ] = useState(undefined)

  const { value } = field

  /**
   * Custom handler to filter options
   * @param {string} code - Input value from the field. Must be seller code
   * @returns {array} list of sellers that already transform into react-select standart option
   */
  const onFilterOptions = async (code) => {
    const additionalFilters = {
      code: code
    }

    try {
      const response = await SellersApiV2.get({ additionalFilters: additionalFilters })
      const sellers  = response.data.sellers

      // if there's no seller, return null
      // so the 'no options' message will be displayed
      if (sellers.length === 0) return null

      return sellers.map((seller) => formatOption(seller))
    }
    catch (error) {
      alert('Something wrong')
    }
  }

  /** Format the option structure to follow react-select convention */
  const formatOption = (seller) => ({
    value : seller.id,
    label : seller.name,
    type  : seller.seller_type,
    code  : seller.code
  })

  /**
   * Create a custom style options
   * @param {object} option - option
   *  */
  const formatOptionLabel = ({ code, label, type }) => (
    <>
      <span className='mr-3'>{ code }</span>
      <span className='mr-3'>{ label }</span>
      <SellerBadge className={ 'badge-md' } seller_type={ type } />
    </>
  )


  useEffect(() => {
    // Call this block only once when value has filled at the first time
    // show the value first before updating the field
    if (!initialOption && value) {
      SellersApiV2.show(value)
        .then((response) => setInitialOption(formatOption(response.data.seller)))
        .catch(() => alert('Something wrong when showing Seller'))
    }

  }, [ initialOption, value ])

  return (
    <SelectField
      { ...props }
      name={ name }
      label={ label }
      required={ required }
      placeholder={ 'Type seller code' }
      defaultValue={ initialOption }
      onFilterOptions={ onFilterOptions }
      formatOptionLabel={ formatOptionLabel }
    />
  )
}

SellerSelectSearchField.propTypes = propTypes

export default SellerSelectSearchField
